export default [
  {
    path: "/export/fiche_projet/:uuid",
    name: "ExportFiche",
    props: true,
    component: () => import("../../../views/Export/Fiche/Projet/Projet")
  },
  {
    path: "/export/index_projet/:ids",
    name: "ExportIndex",
    props: true,
    component: () => import("../../../views/Export/Fiche/Index/Image/Index")
  },
  {
    path: "/export/index_projet_txt/:ids",
    name: "ExportIndexText",
    props: true,
    component: () => import("../../../views/Export/Fiche/Index/Texte/IndexTxt")
  },
  {
    path: "/export/summary/:ids",
    name: "ExportSummary",
    props: true,
    component: () => import("../../../views/Export/Fiche/Summary")
  },
  {
    path: "/export/fichettes/:ids",
    name: "ExportFichettes",
    props: true,
    component: () => import("../../../views/Export/Fiche/FichettesA5")
  },
  {
    path: "/export/kit_presse/:ids",
    name: "ExportKitPresse",
    props: true,
    component: () => import("../../../views/Export/KitPresse")
  },
  {
    path: "/export/agence_about",
    name: "Export About",
    component: () => import("../../../views/Export/AgenceAbout")
  }
];
